import {createContext} from 'react';

export interface UserContext {
  name: String;
  email: String;
  phoneNumber: String;
  otp: String;
  newUser: Boolean;
  accessToken: string;
}
export interface AppContextInterface {
  user: UserContext;
}

export const AppContext: AppContextInterface = {
  user: {
    name: '',
    email: '',
    phoneNumber: '',
    otp: '',
    newUser: true,
    accessToken: '',
  },
};

export const AppCtx = createContext<AppContextInterface | null>(AppContext);
